import React from 'react'
import Card from '../../../Shared/Card/Card'
import Table from '../../../Shared/Table/Table'
import { search_icon } from '../../../Shared/icons'
import useApi from '../../../../hooks/useApi'
import { useParams } from "react-router-dom";
import { currencyFormat } from '../../../Shared/helpers'
import AnimatedCheck from '../../../Shared/Animation/AnimatedCheck'
import AnimatedPlus from '../../../Shared/Animation/AnimatedPlus'
import AnimatedCross from '../../../Shared/Animation/AnimatedCross'
import AnimatedExclamation from '../../../Shared/Animation/AnimatedExclamation'
import CardContainer from '../../../Shared/Card/CardContainer'
import { SlideAnimator, LoadingButton, EmptyResult, LoadingComponent } from 'usbc-web-react-library'
import './MembershipSearch.css'
import MembershipProductOptions from '../../../Shared/MembershipSelection/MembershipProductOptions'

function MembershipSearch(props) {
    const [animationInfo, setAnimationInfo] = React.useState(null);
    const [searchInfo, setSearchInfo] = React.useState({
        firstName: '',
        lastName: '',
        zip: '',
        memberId: ''
    });

    let { lid, season } = useParams();

    const {
        fetchData: getMembers,
        response: members,
        setResponse: setMembers,
        loading: loading,
        error: membersError
    } = useApi();

    const {
        fetchData: getMemberInfo,
        response: memberInfo,
        setResponse: setMemberInfo,
        loading: loadingMemberInfo
    } = useApi();

    function propChange(e) {
        let _prop = { ...searchInfo };
        _prop[e.target.name] = e.target.value;
        setSearchInfo({ ..._prop });
    }

    function findMembers() {
        setMembers(null);
        setMemberInfo(null);
        getMembers({ url: `getmemberships?leagueId=${lid}&seasonId=${season}&memberId=${searchInfo.memberId || ""}&firstName=${searchInfo.firstName || ""}&lastName=${searchInfo.lastName || ""}&zip=${searchInfo.zip || ""}` })
            .then(result => {
                setAnimationInfo({
                    direction: 'top'
                });
            });
    }

    function onProductSelected(searchResult, product) {
        props.updateWizardState((prev) => ({
            ...prev,
            memberId: searchResult.memberId,
            isMemberFoundBySearch: true,
            isPaymentRequired: true,
            productId: product.id
        }));

        props.nextView({
            ...props.wizardState,
            memberId: searchResult.memberId,
            isMemberFoundBySearch: true,
            isPaymentRequired: true,
            productId: product.id 
        });
    }

    function getResultCard(searchResult) {
        if (!searchResult)
            return '';

        let icon;
        let title;
        let body;
        let isClickable;

        switch (searchResult.status) {
            case 1: // 'MembershipFound':
                icon = <AnimatedCheck />;
                title = "Bowler Found: " + searchResult.name;
                body =
                    <>
                        <p className="card-text">A valid Membership was found for {searchResult.name}.</p>
                        <p className="card-text">Click this card to continue</p>
                    </>;
                isClickable = true;
                break;
            case 2: // 'BowlerFoundNoMembership':
                title = "Bowler Found: " + searchResult.name;
                body = <>
                         {searchResult.products?.length &&
                            <div className="text-center">
                                <div><strong>A Membership is required to join this league:</strong></div>
                                <MembershipProductOptions
                                    products={searchResult.products}
                                    showClickText={true} 
                                    onProductClick={(product) => onProductSelected(searchResult, product)}
                                    getIcon={() => <AnimatedPlus />}
                                    /> 
                            </div>}
                        </>;
                isClickable = false;
                break;
            case 3: // 'BowlerAlreadyRegistered':
                icon = <AnimatedExclamation />;
                title = "Bowler Found: " + searchResult.name;
                body = <>
                    <p className="card-text">{searchResult.name} is already participating in this League. Please register a different member.</p>
                </>;
                isClickable = false;
                break;
            case 4: // 'BowlerFoundInvalidAge':
                icon = <AnimatedExclamation />;
                title = "Bowler Found: " + searchResult.name;
                body = <>
                    <p className="card-text" style={{ color: "#b71234" }}>{searchResult.name} found, but their age is not valid for this league type.</p>
                </>;
                isClickable = false;
                break;
                case 5: // 'BowlerFoundInvalidMembership':
                    icon = <AnimatedExclamation />;
                    title = "Bowler Found: " + searchResult.name;
                    body = <>
                        <p className="card-text" style={{ color: "#b71234" }}>{searchResult.message}</p>
                    </>;
                    isClickable = false;
                    break;
            default:
                icon = <AnimatedCross />;
                title = "Bowler not found";
                isClickable = false;
                break;
        }
        var conatinerProps = {}
        if (isClickable === true) {
            conatinerProps = {
                className: "col-md-6 m-5 card-radio",
                onClick: () => {
                    props.updateWizardState((prev) => {
                        return {
                            ...prev,
                            memberId: searchResult.memberId,
                            isMemberFoundBySearch: true
                        };
                    })
                    props.nextView(props.wizardState);
                }
            };
        } else {
            conatinerProps = {
                className: "col-md-6"
            };
        }
        return <div className="row g-3 d-flex justify-content-center">
            <div {...conatinerProps}>
                <CardContainer icon={icon}>
                    <h5 className="card-title"><strong>{title}</strong></h5>
                    {body}
                </CardContainer>
            </div>
        </div>;
    }

    function showMembers() {
    }

    function onMemberSelectedFromTableHandler(row) {
        getMemberInfo({ url: `getmemberships?leagueId=${lid}&seasonId=${season}&memberId=${row.memberId || ""}&firstName=${""}&lastName=${""}&zip=${""}` })
            .then(result => {
                setAnimationInfo({
                    direction: 'top'
                });
            });
    }

    return (
        <>
            <div className="row">
                <div className="col h4 wizard-step-title">
                    {props.step.title}
                </div>
            </div>
            <div className="row">
                <div className="col-lg-5 center-parent fm-card-container">
                    <Card title='USBC Membership' subTitle="Find Bowler's Membership Id Number" icon={search_icon}></Card>
                </div>
                <div className="col-lg-7 center-parent">
                    <form>
                        <div className="row g-3">
                            <div className="col-md-4">
                                <label htmlFor="firstName" className="form-label">First</label>
                                <input type="text" className="form-control" id="firstName" name='firstName' onChange={propChange} />
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="lastName" className="form-label">Last</label>
                                <input type="text" className="form-control" id="lastName" name='lastName' onChange={propChange} />
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="zip" className="form-label">Zip Code</label>
                                <input type="text" className="form-control" id="zip" name='zip' onChange={propChange} pattern="[0-9]{5}" maxLength={'5'}
                                    onKeyPress={(e) => !/[0-9]/.test(e.key) && e.preventDefault()} />
                            </div>
                            <div className="clearfix badge bg-light text-dark">OR</div>
                            <div className="col-md-12">
                                <label htmlFor="memberId" className="form-label">Member ID</label>
                                <input type="text" className="form-control" id="memberId" name='memberId' pattern="[0-9]{5}" onChange={propChange} />
                            </div>
                            <div className="d-grid gap-2 col-6 mx-auto">
                                <LoadingButton className="btn btn-primary bowl-btn w-100" disabled={(searchInfo.firstName === '' || searchInfo.lastName === '' || searchInfo.zip === '') && searchInfo.memberId === ''} loadingText='Finding' loading={loading}
                                    onClick={findMembers}>
                                    Find Member
                                </LoadingButton>
                            </div>
                        </div>
                    </form>
                </div>
                <div className="col-lg-12 mt-2" style={{ overflow: 'hidden' }}>
                    <SlideAnimator animationInfo={animationInfo} callerJob={showMembers}>
                        <LoadingComponent isLoading={() => loadingMemberInfo} description="Loading member information">
                            {memberInfo != null ?
                                <div className='custom-card mt-3 mb-3'>
                                    {getResultCard(memberInfo[0])}
                                </div>
                                :
                                <>
                                    {(members != null && members.length > 0) &&
                                        <div className='custom-card mt-3 mb-3'>
                                            {members.length === 1 ?
                                                getResultCard(members[0])
                                                :
                                                <Table columns={['Name', 'Member ID', 'Association', 'State']} rows={members} ignoreProps={['centerId', 'status', 'needToBuyMembership']}
                                                    onRowSelected={(row) => onMemberSelectedFromTableHandler(row)}></Table>
                                            }
                                        </div>
                                    }
                                    {
                                        (members != null && members.length === 0) &&
                                        <div className='custom-card mt-3 mb-3' style={{ minHeight: '400px' }}>
                                            <EmptyResult text='No Memberships found!' />
                                        </div>
                                    }
                                </>
                            }
                        </LoadingComponent>
                    </SlideAnimator>
                </div>
            </div>
            <div className='wizard-buttons-container'>
                <button type="button" className="btn btn-primary bowl-btn" onClick={props.backView}>Back</button>
            </div>
        </>
    )
}


export default MembershipSearch
